import React, { useEffect, useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";



function PageNotFound({
    user,
}) {
    const navigate = useNavigate()



    useEffect(() => {
        if (!user || Object.keys(user).length === 0) {
            window.location.href = "https://app.despark.io/app/signin"
        } else {
            navigate(user.auth_redirect)
        }
    }, []);

    return <></>
};

export default PageNotFound;
